export const selectors = {
  all: (state) => state.featureFlags || [],
  isEnabled: (name) => (state) => state.featureFlags?.includes(name),
};

export const reducers = {
  featureFlags: featureFlagsReducer,
};

function featureFlagsReducer(state = [], { type, payload } = {}) {
  if (type === 'AUTH/LOGIN_COMPLETE') return [...payload.flags];
  return state;
}
